type PageMainProps = {
  children: React.ReactNode;
};

export default function PageMain({ children }: PageMainProps) {
  return <main className="AppLayoutContainer light-mode">{children}</main>;
}
